import React, { useState, useEffect } from 'react';
import SubscriptionService from '../services/SubscriptionService';
import './PromoBanner.css';

const PromoBanner: React.FC = () => {
  const [promoInfo, setPromoInfo] = useState<any>(null);
  const [daysRemaining, setDaysRemaining] = useState<number>(0);

  useEffect(() => {
    loadPromoInfo();
  }, []);

  const loadPromoInfo = async () => {
    try {
      const subscription = await SubscriptionService.getCurrentSubscription();

      // Check if user has promotional subscription
      if (subscription.metadata) {
        const metadata = typeof subscription.metadata === 'string'
          ? JSON.parse(subscription.metadata)
          : subscription.metadata;

        if (metadata.promoType === 'early_bird' && subscription.currentPeriodEnd) {
          const endDate = new Date(subscription.currentPeriodEnd);
          const now = new Date();
          const timeDiff = endDate.getTime() - now.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

          setPromoInfo({
            message: metadata.promoMessage || 'Early Adopter Bonus',
            userNumber: metadata.userNumber,
            endDate: endDate,
            tierName: subscription.tier.displayName
          });
          setDaysRemaining(daysDiff);
        }
      }
    } catch (error) {
      // User might not have a subscription yet
      console.log('No promo info available');
    }
  };

  if (!promoInfo) return null;

  return (
    <div className="promo-banner">
      <div className="promo-content">
        <span className="promo-icon">🎉</span>
        <div className="promo-text">
          <strong>{promoInfo.message}</strong>
          <p>
            You're user #{promoInfo.userNumber} • {promoInfo.tierName} access •
            <span className="promo-days"> {daysRemaining} days remaining</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
